"use client"

import { useEffect, useState } from "react"
import { cn } from "@/lib/utils"

const sections = [
  { id: "epistemic-crisis", title: "The Epistemic Crisis", number: "01" },
  { id: "market-anomaly", title: "The Market Anomaly", number: "02" },
  { id: "economics-of-thought", title: "Economics of Thought", number: "03" },
  { id: "ontological-grounding", title: "Ontological Grounding", number: "04" },
  { id: "orchestration-dynamics", title: "Orchestration Dynamics", number: "05" },
  { id: "universal-interoperability", title: "Universal Interoperability", number: "06" },
  { id: "epistemic-security", title: "Epistemic Security", number: "07" },
  { id: "european-market", title: "European SME Market", number: "08" },
  { id: "margin-of-safety", title: "Margin of Safety", number: "09" },
]

export function TableOfContents() {
  const [activeSection, setActiveSection] = useState("")

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id)
          }
        })
      },
      {
        rootMargin: "-20% 0px -70% 0px",
        threshold: 0,
      }
    )

    sections.forEach(({ id }) => {
      const element = document.getElementById(id)
      if (element) observer.observe(element)
    })

    return () => observer.disconnect()
  }, [])

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id)
    if (element) {
      const offset = 100
      const elementPosition = element.getBoundingClientRect().top + window.scrollY
      window.scrollTo({
        top: elementPosition - offset,
        behavior: "smooth",
      })
    }
  }

  return (
    <nav className="space-y-1">
      <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-4">
        Contents
      </p>
      {sections.map(({ id, title, number }) => (
        <button
          key={id}
          onClick={() => scrollToSection(id)}
          className={cn(
            "group flex items-start gap-3 w-full text-left py-2 px-3 rounded-md transition-all duration-200",
            activeSection === id
              ? "bg-muted text-foreground"
              : "text-muted-foreground hover:text-foreground hover:bg-muted/50"
          )}
        >
          <span
            className={cn(
              "text-xs font-mono mt-0.5 transition-colors",
              activeSection === id ? "text-accent-primary" : "text-muted-foreground/60"
            )}
          >
            {number}
          </span>
          <span className="text-sm leading-snug">{title}</span>
        </button>
      ))}
    </nav>
  )
}
